module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n.simple-notification-wrapper {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n  width: 400px;\n  z-index: 10000;\n}\n.Cpanel_ .simple-notification-wrapper {\n  top: 140px;\n}\n.Cpanel_user .simple-notification-wrapper {\n  top: 63px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/styles/simple_notification.less
// module id = 1050
// module chunks = 3